import { getUrlParameter, showLoadingBar, removeLoadingBar } from "./global.js";
import AOS from "aos";

(function ($) {
	if ($("body.find-an-organisation").length) {
		var timeoutID = null,
			is_letter = false,
			current_letter = null,
			search_cat = null,
			search_letter,
			search_name,
			url_search_cat,
			page = 1,
			results_container,
			listing_html,
			xhr;

		function process_orgs(data) {
			if (data) {
				results_container = $(".find-an-org-list");
				if (page == 1) {
					results_container.empty();
				}
				if ($.param(data) == "end_of_results=true" || data.length === 0) {
					$(".no-results").removeClass("hidden");
				} else {
					$(".no-results").addClass("hidden");
				}
				if (data["end_of_results"] == true || data.length < 15) {
					$(".load-more-orgs-container").addClass("hidden");
					delete data.end_of_results;
				}
				$.each(data, function (i, val) {
					listing_html = $(".org-template").html();
					listing_html = listing_html.replace("[name]", val.title);

					//HTTP Link
					var prefix = "http://";
					var prefixSSL = "https://";

					if (val.url && !val.url.match(/^http([s]?):\/\/.*/)) {
						var http_link = "http://" + val.website;
					} else {
						var http_link = val.website;
					}
					
					//Expanded details
					if (typeof val.website === "string") {
						var websiteLower = val.website.toLowerCase();
						listing_html = listing_html.replace("[url]", '<i class="text-primary-200 mr-2 far fa-globe"></i> <a class="underline hover:no-underline" href="' + http_link + '" target="_blank">' + websiteLower + "</a><br />");
					} else {
						listing_html = listing_html.replace("[url]", "");
					}
					if (val.phone) {
						listing_html = listing_html.replace("[phone]", '<i class="text-primary-200 mr-2 far fa-phone"></i> <a class="underline hover:no-underline" href="tel:' + val.phone + '">' + val.phone + "</a><br />");
					} else {
						listing_html = listing_html.replace("[phone]", "");
					}
					if (val.membershipID) {
						listing_html = listing_html.replace("[membership_num]", '<i class="text-primary-200 mr-2 far fa-id-card"></i> <a class="hint--top-right hint--info hint--large" data-hint="Evangelical Alliance membership number" href="javascript:;">' + val.membershipID + "</a><br />");
					} else {
						listing_html = listing_html.replace("[membership_num]", "");
					}

					/*
					if (!(val.categories === undefined || val.categories.length == 0)) {
						var catString = '<hr class="border-t-2 my-2"><i class="mt-1 float-left inline-block text-primary-200 mr-2 far fa-list"></i> <ul class="float-left inline-block w-9/12 list-disc ml-6 mb-3">';
						$.each(val.categories, function(i, val) {
							catString += '<li>'+val+'</li>';
						});
						catString += '</ul>';
						listing_html = listing_html.replace('[categories]',catString);
					} else {
						listing_html = listing_html.replace('[categories]','');
					}*/
					/*
					We're not showing emails anymore
					if(val.email) {
						listing_html = listing_html.replace('[email]','<i class="far fa-envelope"></i> <a href="mailto:'+val.email+'" >'+val.email+'</a><br />');
					} else {
						listing_html = listing_html.replace('[email]','');
					}
					*/ listing_html = listing_html.replace("[email]", "");
					results_container.append(listing_html);
				});
				AOS.refresh();
			}
		}

		function search_all() {
			if (page == 1) {
				$(".load-more-orgs-container").removeClass("hidden");
			}
			if (xhr && xhr.readyState != 4) {
				xhr.abort();
			}
			xhr = $.ajax({
				type: "GET",
				url: "/actions/organisation-search/search/getall-organisations-js",
				dataType: "json",
				data: {
					page: page,
				},
				traditional: true,
				beforeSend: function () {
					showLoadingBar();
				},
				success: function (data) {
					is_letter = false;
					process_orgs(data);
					removeLoadingBar();
				},
			});
		}

		function search_org(name, category) {
			$(".alphabet a").removeClass("text-white bg-primary-100");
			if (page == 1) {
				$(".load-more-orgs-container").removeClass("hidden");
			}
			if (name || category) {
				if (name) {
					name = name.replace(/\+/g, " ");
				}

				if (category) {
					if (!name) {
						name = "";
					}
					var search_url = "/membership/our-members/find-an-organisation?name=" + encodeURIComponent(name) + "&category=" + encodeURIComponent(category);
				} else {
					var search_url = "/membership/our-members/find-an-organisation?name=" + encodeURIComponent(name);
				}
				window.history.replaceState({}, document.title, search_url);

				if (xhr && xhr.readyState != 4) {
					xhr.abort();
				}
				xhr = $.ajax({
					type: "GET",
					url: "/actions/organisation-search/search/search-name",
					dataType: "json",
					data: {
						name: name,
						page: page,
					},
					traditional: true,
					beforeSend: function () {
						showLoadingBar();
					},
					success: function (data) {
						is_letter = false;
						process_orgs(data);
						removeLoadingBar();
					},
				});
			} else {
				search_all();
			}
		}

		function get_letter(letter) {
			if (letter) {
				var search_url = "/membership/our-members/find-an-organisation?letter=" + encodeURIComponent(letter);
				window.history.replaceState({}, document.title, search_url);

				if (xhr && xhr.readyState != 4) {
					xhr.abort();
				}
				xhr = $.ajax({
					type: "GET",
					url: "/actions/organisation-search/search/search-letter",
					dataType: "json",
					data: {
						letter: letter,
						page: page,
					},
					traditional: true,
					beforeSend: function () {
						showLoadingBar();
					},
					success: function (data) {
						is_letter = true;
						(current_letter = letter), process_orgs(data);
						removeLoadingBar();
					},
				});
			}
		}

		function load_more_orgs() {
			page++;
			if (is_letter) {
				get_letter(current_letter);
			} else if ($("#search_name").val().length) {
				search_org($("#search_name").val(), search_cat);
			} else if (search_cat) {
				search_org($("#search_name").val(), search_cat);
			} else {
				search_all();
			}
		}

		$("#search_name").keyup(function (e) {
			clearTimeout(timeoutID);
			timeoutID = setTimeout(function () {
				search_org(e.target.value, search_cat);
			}, 500);
		});
		$(document).on("submit", ".org-search-form", function (e) {
			e.preventDefault();
			clearTimeout(timeoutID);
			search_org($("#search_name").val(), search_cat);
			return false;
		});

		$(document).on("click", ".alphabet a", function (e) {
			e.preventDefault();
			if (!$(this).hasClass("disabled")) {
				$("#search_name").val("");
				$(".search_category").val("all");
				search_cat = null;
				$(".alphabet a").removeClass("text-white bg-primary-100");
				$(this).removeClass("text-primary-100").addClass("text-white bg-primary-100");
				var letter = $(this).data("alphabet");
				if (letter !== current_letter) {
					page = 1;
					$(".load-more-orgs-container").removeClass("hidden");
				}
				get_letter(letter);
			}
		});
		$(document).on("click", ".load-more-orgs", function (e) {
			load_more_orgs();
		});

		$(document).on("change", ".search_category", function () {
			page = 1;
			var cat = $(this).find(":selected").val();
			if (cat == "all") {
				cat = null;
			}
			search_cat = cat;
			search_org($("#search_name").val(), cat);
		});

		$(document).ready(function (e) {
			search_letter = getUrlParameter("letter");
			search_name = getUrlParameter("name");
			url_search_cat = getUrlParameter("category");
			if (search_letter) {
				$(".alphabet a").removeClass("text-white bg-primary-100").addClass("text-primary-100");
				$('.alphabet a[data-alphabet="' + search_letter + '"]')
					.removeClass("text-primary-100")
					.addClass("text-white bg-primary-100");
				get_letter(search_letter);
			} else if (search_name) {
				var url_search = decodeURIComponent(getUrlParameter("name"));
				$("#search_name").val(url_search);
				if (url_search_cat) {
					var url_category = decodeURIComponent(getUrlParameter("category"));
					search_cat = url_category;
					$(".search_category").val(url_category);
					search_org(url_search, url_category);
					return true;
				}
				search_org(url_search, null);
			} else if (url_search_cat) {
				var url_category = decodeURIComponent(getUrlParameter("category"));
				search_cat = url_category;
				$(".search_category").val(url_category);
				search_org(null, url_category);
			}
		});
	}
})(jQuery);
